exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.detail-button {\n    font-size: 18px !important;\n    color: #1c869a;\n}\n.detail-button:hover {\n    color: #0c4955;\n    transition: 0.5s;\n}\n", ""]);

// exports
